import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-6 col-xxl-3" }
const _hoisted_4 = { class: "col-sm-6 col-xxl-3" }
const _hoisted_5 = { class: "col-sm-6 col-xxl-3" }
const _hoisted_6 = { class: "col-sm-6 col-xxl-3" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-lg-8" }
const _hoisted_9 = { class: "col-lg-4" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-6 col-lg-12" }
const _hoisted_12 = { class: "col-md-6 col-lg-12" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-xxl-4" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-md-6 col-xxl-12" }
const _hoisted_17 = { class: "col-md-6 col-xxl-12" }
const _hoisted_18 = { class: "col-xxl-8" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-xxl-8 col-lg-7" }
const _hoisted_21 = { class: "col-xxl-4 col-lg-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TotalIncome = _resolveComponent("TotalIncome")!
  const _component_TotalExpenses = _resolveComponent("TotalExpenses")!
  const _component_AccountsReceivable = _resolveComponent("AccountsReceivable")!
  const _component_AccountPayable = _resolveComponent("AccountPayable")!
  const _component_StaticChart = _resolveComponent("StaticChart")!
  const _component_CashEndOfTheMonthChart = _resolveComponent("CashEndOfTheMonthChart")!
  const _component_WeeklyExpensesChart = _resolveComponent("WeeklyExpensesChart")!
  const _component_IncomeSourceChart = _resolveComponent("IncomeSourceChart")!
  const _component_NetProfitChart = _resolveComponent("NetProfitChart")!
  const _component_TransactionHistory = _resolveComponent("TransactionHistory")!
  const _component_DebitCard = _resolveComponent("DebitCard")!
  const _component_ExpenseBreakdownChart = _resolveComponent("ExpenseBreakdownChart")!
  const _component_AddCardDetailModal = _resolveComponent("AddCardDetailModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TotalIncome)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_TotalExpenses)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_AccountsReceivable)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_AccountPayable)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_StaticChart)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_CashEndOfTheMonthChart)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_WeeklyExpensesChart)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_IncomeSourceChart)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_NetProfitChart)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_TransactionHistory)
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_DebitCard)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_ExpenseBreakdownChart)
      ])
    ]),
    _createVNode(_component_AddCardDetailModal)
  ]))
}